export default ({ colors, fontFamilies, fontWeights, fontSizes }) => {
  const styles = {
    globals: {
      // inputs
      '*input': {
        fontSize: fontSizes.big,

        cursor: 'auto',

        color: colors.input.text.default,
        backgroundColor: colors.input.bg.default,

        appearence: 'textfield',
        // Default placeholder color
        '::placeholder': {
          color: colors.input.placeholder.default
        }
      },

      '*select': {
        lineHeight: '1.5rem',

        padding: '1.5rem .625rem .625rem',

        backgroundClip: 'padding-box',

        '-webkit-appearance': 'none',
        '-moz-appearance': 'none',
        appearance: 'none',

        '::-ms-expand': {
          display: 'none'
        }
      },
      // links
      '*a': {
        display: 'inline-block',

        transition: 'all 100ms',
        textDecoration: 'none',

        color: colors.link.text.default,

        ':hover': {
          color: colors.link.text.hover
        },
        ':focus': {
          color: colors.link.text.hover
        }
      },
      // pages
      // Metro mode compatibility.
      '*@-ms-viewport': {
        width: 'device-width'
      },

      '**': {
        boxSizing: 'border-box'
      },

      '*html': {
        fontSize: '100%',

        color: colors.common.html.text.default,
        backgroundColor: colors.common.html.bg.default
      },

      '*body': {
        fontFamily: fontFamilies.default,
        fontWeight: fontWeights.body.default,
        margin: '0',
        padding: '0',

        backgroundColor: colors.common.body.bg.default,

        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '-webkit-tap-highlight-color': colors.common.tap.default
      },

      '*::selection': {
        color: colors.common.selection.text.default,
        backgroundColor: colors.common.selection.bg.default,
        'text-shadow': 'none'
      },
      '*::-moz-selection': {
        color: colors.common.selection.text.default,
        backgroundColor: colors.common.selection.bg.default,
        'text-shadow': 'none'
      },
      // separator
      '*hr': {
        display: 'block',

        width: '100%',
        height: '1px',

        border: '0',
        backgroundColor: colors.common.separator
      },
      // typography
      '*h1': {
        textAlign: 'center',

        fontSize: '1.5rem',

        marginBottom: '10px',

        color: colors.common.headings.h1
      },

      '*h2': {
        textAlign: 'center',

        fontSize: '1rem',
        'font-style': 'normal',

        color: colors.common.headings.h2
      },

      '*h3': {
        textAlign: 'center',

        fontSize: '1.2rem'
      },

      '*h4': {
        textAlign: 'center',
        fontSize: '1rem',
        marginTop: '3rem',
        marginBottom: 'auto'
      },

      '*h5': {
        textAlign: 'center',

        fontSize: '2vmax'
      },

      '*h6': {
        textAlign: 'center',

        fontSize: '1.6vmax'
      },

      '*p': {
        fontSize: '1rem',
        lineHeight: '1.5rem',

        color: colors.common.paragraph.default
      },

      '*b': {
        fontWeight: fontWeights.b.default
      }
    }
  }

  return styles
}



// WEBPACK FOOTER //
// ./styles/generics/styles.js